import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Logo from "./Logo";

const Navbar = () => {
    const location = useLocation();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const navLinks = [
        { name: "HOME", path: "/" },
        { name: "ABOUT", path: "/about" },
        { name: "PRODUCTS", path: "/products" },
        { name: "CONTACT", path: "/contact" },
    ];

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    return (
        <header className="fixed top-0 left-0 w-full z-[100] bg-[#f8ecdf] border-b border-brand-gold/80">
            <div className="container-x flex items-center justify-between h-[80px] md:h-[90px]">

                {/* 1. LOGO */}
                <div className="flex-1 flex justify-start">
                    <Link to="/" onClick={() => setIsMenuOpen(false)}>
                        <Logo />
                    </Link>
                </div>

                {/* 2. MENU (Hidden on Tabs/Mobile, visible only on Desktop LG+) */}
                <nav className="hidden lg:flex items-center gap-10">
                    {navLinks.map((link) => (
                        <Link
                            key={link.name}
                            to={link.path}
                            className={`text-[12px] font-medium tracking-[0.25em] transition-all duration-300 hover:text-brand-brown ${location.pathname === link.path
                                    ? "text-brand-brown border-b border-brand-brown"
                                    : "text-[#1a1a1a]"
                                }`}
                        >
                            {link.name}
                        </Link>
                    ))}
                </nav>

                {/* 3. BUTTON (Visible on LG+ Screens) */}
                <div className="flex-1 hidden lg:flex justify-end">
                    <Link
                        to="/contact"
                        className="inline-flex items-center px-8 py-3.5 text-[11px] font-bold tracking-[0.2em] bg-brand-brown text-white hover:bg-[#6f2e24] transition-all duration-300"
                    >
                        REQUEST QUOTE
                    </Link>
                </div>

                {/* MOBILE/TAB TOGGLE (Visible on everything below 1024px) */}
                <div className="lg:hidden flex items-center">
                    <button
                        onClick={toggleMenu}
                        className="p-2 focus:outline-none z-[110]"
                        aria-label="Toggle Menu"
                    >
                        {/* Hamburger Icon Animation */}
                        <div className={`w-6 h-0.5 bg-brand-brown transition-all duration-300 ${isMenuOpen ? "rotate-45 translate-y-2" : "mb-1.5"}`}></div>
                        <div className={`w-6 h-0.5 bg-brand-brown transition-all duration-300 ${isMenuOpen ? "opacity-0" : "mb-1.5"}`}></div>
                        <div className={`w-6 h-0.5 bg-brand-brown transition-all duration-300 ${isMenuOpen ? "-rotate-45 -translate-y-1" : ""}`}></div>
                    </button>
                </div>

                {/* MOBILE MENU OVERLAY */}
                <div className={`fixed inset-0 bg-[#fdfcfb] z-[100] transition-transform duration-500 ease-in-out ${isMenuOpen ? "translate-x-0" : "translate-x-full"} lg:hidden`}>
                    <div className="flex flex-col items-center justify-center h-full gap-8">
                        {navLinks.map((link) => (
                            <Link
                                key={link.name}
                                to={link.path}
                                onClick={toggleMenu}
                                className={`text-[18px] font-medium tracking-[0.3em] ${location.pathname === link.path ? "text-brand-brown" : "text-[#1a1a1a]"
                                    }`}
                            >
                                {link.name}
                            </Link>
                        ))}
                        <Link
                            to="/contact"
                            onClick={toggleMenu}
                            className="mt-4 px-10 py-4 bg-brand-brown text-white text-[12px] font-bold tracking-[0.2em]"
                        >
                            REQUEST QUOTE
                        </Link>
                    </div>
                </div>

            </div>
        </header>
    );
};

export default Navbar;